export type Feature =
  'inspections'
  | 'issues'
  | 'sensors'
  | 'analytics'
  | 'groups'
  | 'entityItems'
  | 'roles'
  | 'additionalNotificationChannels'
  | 'extendUserQuota'
  | 'customReports'
  | 'scores'
  | 'checklists'
  | 'entityFolders'
  | 'entityTypes'
  | 'schedules'
  | 'approvals';

export type Quota =
  'user'
  | 'inspection';

export enum Permissions {
  MANAGE_BILLING = 'manageBilling',
  MANAGE_USERS = 'manageUsers',
  MANAGE_ENTITY_ITEMS = 'manageEntityItems',
  MANAGE_ENTITY_FOLDERS = 'manageEntityFolders',
  MANAGE_ENTITY_TYPES = 'manageEntityTypes',
  MANAGE_ENTITY_PROPERTIES = 'manageEntityProperties',
  MANAGE_PERMISSIONS = 'managePermissions',
  MANAGE_CATEGORIES = 'manageCategories',
  MANAGE_CHECKLISTS = 'manageChecklists',
  MANAGE_DRAFT_INSPECTIONS = 'manageDraftInspections',
  CONDUCT_OPEN_INSPECTIONS = 'conductOpenInspections',
  VIEW_ALL_INSPECTION = 'viewAllInspections',
  VIEW_OWN_INSPECTION = 'viewOwnInspections',
  EDIT_ALL_INSPECTION = 'editAllInspections',
  EDIT_OWN_INSPECTION = 'editOwnInspections',
  CREATE_ISSUE = 'createIssue',
  CREATE_ISSUE_WITH_ASSIGNEE = 'createIssueWithAssignee',
  MANAGE_OWN_ISSUE = 'manageOwnIssues',
  MANAGE_ALL_ISSUE = 'manageAllIssues',
  MANAGE_ASSIGNED_SOLVED_ISSUES = 'manageAssignedSolvedIssues',
  MANAGE_HARDWARE = 'manageHardware',
  VIEW_ALL_ANALYTICS = 'viewAllAnalytics',
  MANAGE_ALL_ANALYTICS = 'manageAllAnalytics',
  MANAGE_OWN_ANALYTICS = 'manageOwnAnalytics',
  VIEW_SENSOR_REPORT = 'viewSensorReports',
  VIEW_ALL_UPCOMING_INSPECTIONS = 'viewAllUpcomingInspections',
  VIEW_OWN_UPCOMING_INSPECTIONS = 'viewOwnUpcomingInspections',
  MANAGE_INTEGRATIONS = 'manageIntegrations',
  APPROVE_ALL_INSPECTIONS = 'approveAllInspections',
  APPROVE_ASSIGNED_INSPECTIONS = 'approveAssignedInspections',
  APPROVE_ALL_ACTIONS = 'approveAllActions',
  APPROVE_ASSIGNED_ACTIONS = 'approveAssignedActions'
}

export const analyticsPermissions = [
  Permissions.VIEW_ALL_ANALYTICS,
  Permissions.MANAGE_ALL_ANALYTICS,
  Permissions.MANAGE_OWN_ANALYTICS,
];

export const approvalsPermissions = [
  Permissions.APPROVE_ALL_INSPECTIONS,
  Permissions.APPROVE_ASSIGNED_INSPECTIONS,
  Permissions.APPROVE_ALL_ACTIONS,
  Permissions.APPROVE_ASSIGNED_ACTIONS,
];

export const actionApprovalsPermissions = [
  Permissions.APPROVE_ALL_ACTIONS,
  Permissions.APPROVE_ASSIGNED_ACTIONS,
];

export const inspectionApprovalsPermissions = [
  Permissions.APPROVE_ALL_INSPECTIONS,
  Permissions.APPROVE_ASSIGNED_INSPECTIONS,
];
